import Vue from 'vue'

import waves from './waves/index.js'


const directives = [
  waves
];

const install = {
  install: function(Vue){
    directives.map(directive => {
      Vue.directive(directive.name, directive);
    });
  }
}

export default install





// WEBPACK FOOTER //
// ./src/common/directive/index.js